import { LocalStore } from './localStore.js';
import './tslib.es6-b2cb7a63.js';
import './memoryStorage.js';
import './_storageService-5b9aed06.js';

var LocalCache = /** @class */ (function () {
    function LocalCache(defaultLifeTime, storePrefix) {
        if (defaultLifeTime === void 0) { defaultLifeTime = 7200000; }
        if (storePrefix === void 0) { storePrefix = null; }
        this.defaultLifeTime = defaultLifeTime;
        this.quoteErrors = 0;
        this.localStore = new LocalStore(storePrefix);
    }
    Object.defineProperty(LocalCache.prototype, "now", {
        get: function () {
            return Math.round(Date.now() / 1000);
        },
        enumerable: false,
        configurable: true
    });
    LocalCache.prototype.get = function (key, isDeleteExpired, getExpired) {
        if (isDeleteExpired === void 0) { isDeleteExpired = true; }
        var val = this.localStore.get(key);
        if (val && val.expires > this.now) {
            return val.value;
        }
        if (val && isDeleteExpired) {
            this.expire(key);
        }
        return null;
    };
    LocalCache.prototype.set = function (key, value, lifeTimeMS) {
        if (lifeTimeMS === void 0) { lifeTimeMS = this.defaultLifeTime; }
        try {
            var state = this.localStore.set(key, {
                expires: (lifeTimeMS / 1000) + this.now,
                value: value
            });
            this.quoteErrors = 0;
            return state;
        }
        catch (e) {
            console.error(e);
            if (~e.message.indexOf('quota') && this.quoteErrors === 0) {
                this.quoteErrors += 1;
                this.clean(true);
                return this.set(key, value, lifeTimeMS);
            }
        }
    };
    LocalCache.prototype.isExpired = function (record) {
        return record && record.expires && record.expires < this.now;
    };
    LocalCache.prototype.clean = function (force) {
        if (force === void 0) { force = false; }
        var records = this.localStore.getAll();
        for (var key in records) {
            if (key.indexOf(this.localStore.prefix) !== -1 && records[key] && records[key].expires && records[key].value && (force || this.isExpired(records[key]))) {
                this.localStore.removeItem(key);
            }
        }
        return true;
    };
    LocalCache.prototype.expire = function (key) {
        var _this = this;
        if (Array.isArray(key)) {
            key.map(function (k) {
                _this.localStore.delete(k);
            });
            return true;
        }
        else {
            return this.localStore.delete(key);
        }
    };
    LocalCache.prototype.delIfExpire = function (key) {
        var val = this.localStore.get(key);
        if (val && val.expires < this.now) {
            this.expire(key);
            return true;
        }
        return false;
    };
    return LocalCache;
}());
var localCache = new LocalCache();

export { LocalCache, localCache };
